"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.Pencil = function (props) {
  var _a;

  return react_1.default.createElement("svg", __assign({}, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-332",
    d: "M45.961,2.545l-0.533-0.533C44.309,0.887,43.426,0,42,0c-1.365,0-1.809,0.383-2.535,1.119L7.293,33.293L7.165,33.42 L0.986,47.014l13.594-6.18L46.846,8.568C47.412,8.008,47.998,7.428,48,6.002C48.002,4.57,47.01,3.586,45.961,2.545z M8.029,41.615 l-1.645-1.645l1.928-4.244l3.961,3.961L8.029,41.615z M14,38.586L9.414,34L35,8.414L39.586,13L14,38.586z M45.438,7.148L41,11.586 L36.414,7l4.293-4.293l0.18-0.182C41.406,2,41.406,2,42,2c0.568,0,1.053,0.461,2.008,1.422l0.543,0.543 C45.477,4.883,46,5.43,46,5.998C45.998,6.592,45.912,6.678,45.438,7.148z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-332"
  }));
};